import APIHeaders from '../entities/APIHeaders';

export default (params: any) => {
  const headers = new APIHeaders()

  // ヘッダに許可されない文字が入ってくる可能性のある項目についてはエスケープしでセット
  headers.Authorization = params.Authorization
  headers.Locale = params.Locale
  headers['Application-version'] = params['Application-version']
  headers.Termname = escape(params.Termname)
  headers.Os = params.Os
  headers.Devicename = escape(params.Devicename)
  headers.Deviceidentifier = params.Deviceidentifier
  headers['Content-Type'] = 'application/json'

  return headers
}

const escape = (string?: string) : string | undefined => {
  if (string != null) {
    return encodeURIComponent(string)
  }
  return undefined
}
